// extracted by mini-css-extract-plugin
var _1 = "PopOverArrow-module__arrowBg--VVYHW";
var _2 = "PopOverArrow-module__arrowStroke--QiDiX";
export { _1 as "arrowBg", _2 as "arrowStroke" }
